<template>
  <div :class="[expand ? 'expand':'' , 'itemWrap']">
    <label for="">{{label}}</label>
    <div class="itemCon">
      <slot />
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  props:{
    label:String,
    expand:Boolean,
  },
  data () {
    return {
      title: '',
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.itemWrap{
  line-height:0.8rem;
  height:1.6rem;
  font-size:16px;
  padding: 0.4rem 0 0.4rem 0.5333rem;
  border-bottom:1px solid #efefef;
  display: flex;
  align-items: center;
  position:relative;
  label{
    min-width: 2.1333rem;
  }
}
.itemCon{
  width: 100%;
  padding-left: 0.2133rem;
}
.expand::after{
  content:"";
  position:absolute;
  top:25px;
  right:20px;
  width:0.2667rem;
  height:0.2667rem;
  border:1px #999 solid;
  border-right-width:0;
  border-bottom-width:0;
  transform: rotate(135deg);
}
</style>